module.exports = __webpack_public_path__ + "img/prize-03.2451c356.png";